export const translations = {
  id: {
    nav: {
      browse: "Jelajahi",
      photos: "Foto",
      graphics: "Desain Grafis",
      pricing: "Harga",
      contributor: "Portal Kontributor",
      sell: "Jual Karya",
      login: "Masuk",
      register: "Daftar",
      logout: "Keluar",
      library: "Pustaka Saya",
      studio: "Studio Kontributor",
      admin: "Konsol Admin",
      dashboard: "Dasbor",
      searchPlaceholder: "Cari foto, vektor, template...",
    },
    hero: {
      badge: "Marketplace Aset Digital #1 di Indonesia",
      title1: "Foto & Desain Grafis",
      title2: "Premium untuk Kreasi Anda",
      subtitle:
        "Jutaan foto, ilustrasi, vektor 3D, dan template berkualitas tinggi dari kontributor terbaik. Lisensi jelas, unduh instan.",
      searchBtn: "Cari",
      browseAll: "Lihat Semua Aset",
      becomeContributor: "Jadi Kontributor",
      stat1: "Aset Digital",
      stat2: "Kontributor",
      stat3: "Unduhan",
    },
    section: {
      featured: "Aset Unggulan",
      featuredSub: "Pilihan terbaik kurator kami minggu ini",
      trending: "Sedang Tren",
      categories: "Kategori Populer",
      topContributors: "Kontributor Teratas",
      viewAll: "Lihat semua",
    },
    card: {
      addToCart: "Tambah ke Keranjang",
      buyNow: "Beli Sekarang",
      preview: "Pratinjau",
      by: "oleh",
      downloads: "unduhan",
    },
    detail: {
      license: "Tipe Lisensi",
      standard: "Standar",
      commercial: "Komersial",
      standardDesc: "Untuk penggunaan pribadi & media sosial",
      commercialDesc: "Untuk iklan, produk & penjualan ulang",
      details: "Detail Aset",
      resolution: "Resolusi",
      fileSize: "Ukuran File",
      format: "Format",
      category: "Kategori",
      tags: "Tag",
      relatedTitle: "Aset Serupa",
      inCart: "Sudah di Keranjang",
    },
    cart: {
      title: "Keranjang Belanja",
      empty: "Keranjang Anda kosong",
      emptyDesc: "Jelajahi katalog dan tambahkan aset favorit Anda.",
      subtotal: "Subtotal",
      discount: "Diskon",
      total: "Total",
      promo: "Kode promo",
      apply: "Terapkan",
      checkout: "Lanjut ke Pembayaran",
      remove: "Hapus",
      item: "item",
      items: "item",
    },
    checkout: {
      title: "Pembayaran",
      summary: "Ringkasan Pesanan",
      method: "Metode Pembayaran",
      qris: "QRIS",
      bank: "Transfer Bank",
      card: "Kartu Kredit",
      pay: "Bayar",
      processing: "Memproses...",
      loginRequired: "Silakan masuk untuk melanjutkan pembayaran",
      success: "Pembayaran berhasil! Aset Anda siap diunduh.",
      mockNote: "Pembayaran diproses aman melalui Tarapay (QRIS). Pindai kode QR untuk menyelesaikan pembayaran.",
      scanTitle: "Pindai QRIS untuk Membayar",
      scanDesc: "Buka aplikasi e-wallet atau mobile banking Anda, lalu pindai kode QRIS di bawah ini.",
      waiting: "Menunggu pembayaran...",
      checkStatus: "Cek Status Pembayaran",
      copyQris: "Salin kode QRIS",
      orderNo: "No. Order",
      paidTitle: "Pembayaran Diterima!",
      gatewayError: "Gagal membuat pembayaran. Silakan coba lagi.",
      expiresIn: "Berlaku",
    },
    library: {
      title: "Pustaka Saya",
      subtitle: "Semua aset yang telah Anda beli",
      download: "Unduh",
      licenseKey: "Kunci Lisensi",
      empty: "Belum ada aset yang dibeli",
      emptyDesc: "Aset yang Anda beli akan muncul di sini.",
      purchased: "Dibeli",
    },
    studio: {
      title: "Studio Kontributor",
      subtitle: "Unggah, kelola, dan pantau penghasilan karya Anda",
      upload: "Unggah Aset",
      uploadTitle: "Unggah Aset Baru",
      myAssets: "Aset Saya",
      earnings: "Penghasilan",
      totalEarnings: "Total Penghasilan",
      totalSales: "Total Penjualan",
      totalAssets: "Total Aset",
      totalDownloads: "Total Unduhan",
      earningsChart: "Grafik Penghasilan",
      dropFile: "Klik atau seret file ke sini",
      fileHint: "PNG, JPG, WEBP, SVG hingga 25MB",
      titleId: "Judul (Indonesia)",
      titleEn: "Judul (Inggris)",
      descId: "Deskripsi (Indonesia)",
      descEn: "Deskripsi (Inggris)",
      category: "Kategori",
      type: "Tipe Aset",
      tags: "Tag (pisahkan dengan koma)",
      price: "Harga (IDR)",
      submit: "Kirim untuk Ditinjau",
      submitting: "Mengunggah...",
      uploadSuccess: "Aset berhasil diunggah! Menunggu persetujuan.",
      statusApproved: "Disetujui",
      statusPending: "Menunggu",
      statusRejected: "Ditolak",
      withdrawTab: "Tarik Dana",
      availableBalance: "Saldo Tersedia",
      withdrawn: "Sudah Ditarik",
      bankCode: "Kode Bank",
      accountNo: "No. Rekening",
      accountName: "Nama Pemilik Rekening",
      amount: "Jumlah (IDR)",
      requestWithdraw: "Ajukan Penarikan",
      withdrawHistory: "Riwayat Penarikan",
      withdrawSuccess: "Permintaan penarikan berhasil dikirim",
      noWithdrawals: "Belum ada penarikan",
      minWithdraw: "Minimum penarikan Rp 10.000",
    },
    withdrawStatus: {
      processing: "Diproses",
      success: "Berhasil",
      failed: "Gagal",
      pending: "Menunggu",
      approved: "Disetujui",
      rejected: "Ditolak",
    },
    admin: {
      title: "Konsol Admin",
      subtitle: "Tinjau kiriman kontributor & pantau platform",
      tabAssets: "Moderasi Aset",
      tabWithdrawals: "Pengajuan & Riwayat Penarikan",
      withdrawalsTitle: "Pengajuan & Riwayat Penarikan (Settlement)",
      withdrawalsSubtitle: "Kelola pengajuan pencairan dana kontributor, lakukan disburse via Tarapay, dan pantau riwayat penarikan.",
      totalWithdrawals: "Total Pengajuan",
      pendingWithdrawals: "Perlu Diproses",
      successWithdrawals: "Berhasil Dicairkan",
      disburse: "Disburse (Payout)",
      approveWithdraw: "Setujui",
      rejectWithdraw: "Tolak",
      manualSuccess: "Selesai Manual",
      trace: "Telusuri",
      searchWithdrawals: "Cari nomor order, rekening, atau nama kontributor...",
      noWithdrawals: "Tidak ada data penarikan",
      confirmRejectWithdraw: "Tolak pengajuan penarikan ini? Dana akan dikembalikan ke saldo kontributor.",
      disburseSuccess: "Payout berhasil dikirim ke Tarapay",
      rejectSuccessWithdraw: "Penarikan ditolak — saldo otomatis dikembalikan ke kontributor",
      approveSuccessWithdraw: "Pengajuan penarikan disetujui",
      manualSuccessWithdraw: "Penarikan ditandai selesai secara manual",
      queue: "Antrean Moderasi",
      all: "Semua",
      pending: "Menunggu",
      approved: "Disetujui",
      rejected: "Ditolak",
      approve: "Setujui",
      reject: "Tolak",
      feature: "Jadikan Unggulan",
      unfeature: "Hapus Unggulan",
      rejectReason: "Alasan penolakan",
      totalAssets: "Total Aset",
      revenue: "Pendapatan",
      users: "Pengguna",
      orders: "Pesanan",
      approveSuccess: "Aset disetujui",
      rejectSuccess: "Aset ditolak",
      merchantBalance: "Saldo Merchant (Tarapay)",
      checkBalance: "Cek Saldo",
      balanceUnavailable: "Saldo belum tersedia (endpoint menunggu konfirmasi)",
    },
    auth: {
      loginTitle: "Selamat Datang Kembali",
      registerTitle: "Buat Akun",
      name: "Nama Lengkap",
      email: "Email",
      password: "Kata Sandi",
      role: "Saya ingin",
      roleBuyer: "Membeli aset",
      roleContributor: "Menjual karya saya",
      loginBtn: "Masuk",
      registerBtn: "Daftar",
      noAccount: "Belum punya akun?",
      hasAccount: "Sudah punya akun?",
      switchRegister: "Daftar di sini",
      switchLogin: "Masuk di sini",
      loginSuccess: "Berhasil masuk!",
      registerSuccess: "Akun berhasil dibuat!",
    },
    common: {
      all: "Semua",
      filters: "Filter",
      sort: "Urutkan",
      sortNewest: "Terbaru",
      sortPopular: "Terpopuler",
      sortPriceLow: "Harga Terendah",
      sortPriceHigh: "Harga Tertinggi",
      priceRange: "Rentang Harga",
      type: "Tipe",
      photo: "Foto",
      graphic: "Grafis",
      results: "hasil",
      noResults: "Tidak ada aset yang cocok",
      loading: "Memuat...",
      loadMore: "Muat lebih banyak",
      close: "Tutup",
    },
    footer: {
      tagline: "Marketplace aset digital untuk kreator modern.",
      explore: "Jelajahi",
      company: "Perusahaan",
      about: "Tentang Kami",
      careers: "Karir",
      contact: "Kontak",
      legal: "Legal",
      terms: "Syarat & Ketentuan",
      privacy: "Kebijakan Privasi",
      license: "Lisensi",
      rights: "Semua hak dilindungi.",
    },
  },
  en: {
    nav: {
      browse: "Browse",
      photos: "Photos",
      graphics: "Graphic Design",
      pricing: "Pricing",
      contributor: "Contributor Portal",
      sell: "Sell Your Work",
      login: "Log In",
      register: "Sign Up",
      logout: "Log Out",
      library: "My Library",
      studio: "Contributor Studio",
      admin: "Admin Console",
      dashboard: "Dashboard",
      searchPlaceholder: "Search photos, vectors, templates...",
    },
    hero: {
      badge: "#1 Digital Asset Marketplace in Indonesia",
      title1: "Premium Photos & Graphics",
      title2: "for Your Creative Work",
      subtitle:
        "Millions of high-quality photos, illustrations, 3D vectors, and templates from top contributors. Clear licensing, instant download.",
      searchBtn: "Search",
      browseAll: "Browse All Assets",
      becomeContributor: "Become a Contributor",
      stat1: "Digital Assets",
      stat2: "Contributors",
      stat3: "Downloads",
    },
    section: {
      featured: "Featured Assets",
      featuredSub: "Our curators' top picks this week",
      trending: "Trending Now",
      categories: "Popular Categories",
      topContributors: "Top Contributors",
      viewAll: "View all",
    },
    card: {
      addToCart: "Add to Cart",
      buyNow: "Buy Now",
      preview: "Preview",
      by: "by",
      downloads: "downloads",
    },
    detail: {
      license: "License Type",
      standard: "Standard",
      commercial: "Commercial",
      standardDesc: "For personal use & social media",
      commercialDesc: "For ads, products & resale",
      details: "Asset Details",
      resolution: "Resolution",
      fileSize: "File Size",
      format: "Format",
      category: "Category",
      tags: "Tags",
      relatedTitle: "Similar Assets",
      inCart: "In Cart",
    },
    cart: {
      title: "Shopping Cart",
      empty: "Your cart is empty",
      emptyDesc: "Browse the catalog and add your favorite assets.",
      subtotal: "Subtotal",
      discount: "Discount",
      total: "Total",
      promo: "Promo code",
      apply: "Apply",
      checkout: "Proceed to Checkout",
      remove: "Remove",
      item: "item",
      items: "items",
    },
    checkout: {
      title: "Checkout",
      summary: "Order Summary",
      method: "Payment Method",
      qris: "QRIS",
      bank: "Bank Transfer",
      card: "Credit Card",
      pay: "Pay",
      processing: "Processing...",
      loginRequired: "Please log in to continue checkout",
      success: "Payment successful! Your assets are ready to download.",
      mockNote: "Payments are processed securely via Tarapay (QRIS). Scan the QR code to complete payment.",
      scanTitle: "Scan QRIS to Pay",
      scanDesc: "Open your e-wallet or mobile banking app and scan the QRIS code below.",
      waiting: "Waiting for payment...",
      checkStatus: "Check Payment Status",
      copyQris: "Copy QRIS code",
      orderNo: "Order No.",
      paidTitle: "Payment Received!",
      gatewayError: "Failed to create payment. Please try again.",
      expiresIn: "Expires in",
    },
    library: {
      title: "My Library",
      subtitle: "All the assets you have purchased",
      download: "Download",
      licenseKey: "License Key",
      empty: "No purchased assets yet",
      emptyDesc: "Assets you buy will appear here.",
      purchased: "Purchased",
    },
    studio: {
      title: "Contributor Studio",
      subtitle: "Upload, manage, and track your earnings",
      upload: "Upload Asset",
      uploadTitle: "Upload New Asset",
      myAssets: "My Assets",
      earnings: "Earnings",
      totalEarnings: "Total Earnings",
      totalSales: "Total Sales",
      totalAssets: "Total Assets",
      totalDownloads: "Total Downloads",
      earningsChart: "Earnings Chart",
      dropFile: "Click or drag file here",
      fileHint: "PNG, JPG, WEBP, SVG up to 25MB",
      titleId: "Title (Indonesian)",
      titleEn: "Title (English)",
      descId: "Description (Indonesian)",
      descEn: "Description (English)",
      category: "Category",
      type: "Asset Type",
      tags: "Tags (comma separated)",
      price: "Price (IDR)",
      submit: "Submit for Review",
      submitting: "Uploading...",
      uploadSuccess: "Asset uploaded successfully! Awaiting approval.",
      statusApproved: "Approved",
      statusPending: "Pending",
      statusRejected: "Rejected",
      withdrawTab: "Withdraw",
      availableBalance: "Available Balance",
      withdrawn: "Withdrawn",
      bankCode: "Bank Code",
      accountNo: "Account Number",
      accountName: "Account Holder Name",
      amount: "Amount (IDR)",
      requestWithdraw: "Request Withdrawal",
      withdrawHistory: "Withdrawal History",
      withdrawSuccess: "Withdrawal request submitted",
      noWithdrawals: "No withdrawals yet",
      minWithdraw: "Minimum withdrawal Rp 10,000",
    },
    withdrawStatus: {
      processing: "Processing",
      success: "Success",
      failed: "Failed",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
    },
    admin: {
      title: "Admin Console",
      subtitle: "Review contributor submissions & monitor the platform",
      tabAssets: "Asset Moderation",
      tabWithdrawals: "Withdrawals & Settlements",
      withdrawalsTitle: "Contributor Withdrawals & Settlements",
      withdrawalsSubtitle: "Manage contributor payout requests, disburse via Tarapay, and monitor withdrawal history.",
      totalWithdrawals: "Total Requests",
      pendingWithdrawals: "Pending Action",
      successWithdrawals: "Successfully Disbursed",
      disburse: "Disburse (Payout)",
      approveWithdraw: "Approve",
      rejectWithdraw: "Reject",
      manualSuccess: "Mark Manual Success",
      trace: "Trace",
      searchWithdrawals: "Search by order no, account, or contributor name...",
      noWithdrawals: "No withdrawal records found",
      confirmRejectWithdraw: "Reject this withdrawal request? Funds will be returned to contributor's balance.",
      disburseSuccess: "Payout successfully dispatched to Tarapay",
      rejectSuccessWithdraw: "Withdrawal rejected — funds returned to contributor",
      approveSuccessWithdraw: "Withdrawal request approved",
      manualSuccessWithdraw: "Withdrawal marked as completed manually",
      queue: "Moderation Queue",
      all: "All",
      pending: "Pending",
      approved: "Approved",
      rejected: "Rejected",
      approve: "Approve",
      reject: "Reject",
      feature: "Set Featured",
      unfeature: "Unfeature",
      rejectReason: "Rejection reason",
      totalAssets: "Total Assets",
      revenue: "Revenue",
      users: "Users",
      orders: "Orders",
      approveSuccess: "Asset approved",
      rejectSuccess: "Asset rejected",
      merchantBalance: "Merchant Balance (Tarapay)",
      checkBalance: "Check Balance",
      balanceUnavailable: "Balance not available yet (endpoint pending confirmation)",
    },
    auth: {
      loginTitle: "Welcome Back",
      registerTitle: "Create Account",
      name: "Full Name",
      email: "Email",
      password: "Password",
      role: "I want to",
      roleBuyer: "Buy assets",
      roleContributor: "Sell my work",
      loginBtn: "Log In",
      registerBtn: "Sign Up",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      switchRegister: "Sign up here",
      switchLogin: "Log in here",
      loginSuccess: "Logged in successfully!",
      registerSuccess: "Account created successfully!",
    },
    common: {
      all: "All",
      filters: "Filters",
      sort: "Sort",
      sortNewest: "Newest",
      sortPopular: "Most Popular",
      sortPriceLow: "Price: Low to High",
      sortPriceHigh: "Price: High to Low",
      priceRange: "Price Range",
      type: "Type",
      photo: "Photo",
      graphic: "Graphic",
      results: "results",
      noResults: "No assets match your search",
      loading: "Loading...",
      loadMore: "Load more",
      close: "Close",
    },
    footer: {
      tagline: "The digital asset marketplace for modern creators.",
      explore: "Explore",
      company: "Company",
      about: "About Us",
      careers: "Careers",
      contact: "Contact",
      legal: "Legal",
      terms: "Terms & Conditions",
      privacy: "Privacy Policy",
      license: "Licenses",
      rights: "All rights reserved.",
    },
  },
};
